// import PageIndex from "@/views/Index";

export default [
  {
    path: "/",
    name: "index",
    redirect: "/designs"
  },
  {
    path: "/login",
    name: "login",
    components: {
      login: () => import(/* webpackChunkName: "about" */ "@/views/Login.vue")
    }
  },
  {
    path: "/adminDashboard",
    name: "adminDashboard",
    component: () => import("@/views/AdminDashboard.vue")
  },
  {
    path: "/designerDashboard",
    name: "designerDashboard",
    component: () => import("@/views/DesignerDashboard.vue")
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/Profile.vue")
  },
  {
    path: "/users",
    name: "users",
    component: () => import("@/views/Users.vue")
  },
  {
    path: "/accounts",
    name: "accounts",
    component: () => import("@/views/Accounts.vue")
  },
  {
    path: "/designs",
    name: "designs",
    component: () => import("@/views/Designs.vue"),
    children: [
      {
        path: ":id",
        name: "design",
        components: {
          modal: () => import("@/components/DesignRow.vue")
        },
        meta: {
          showModal: true
        }
      }
    ],
    meta: {
      showModal: false
    }
  }
];
